import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultImageModule } from '@shared/components/games';

@Component({
    selector: 'ms-menar-background-hero',
    imports: [CommonModule, DefaultImageModule],
    templateUrl: './menar-background-hero.component.html',
    styleUrls: ['./menar-background-hero.component.scss']
})
export class MenarBackgroundHeroComponent {
  @Input() hero: string;

  @Input() heroTeacher: string;
}
